import { LitElement, html } from 'lit';
import { FitStorageBehavior } from '../fit-storage/fit-storage-behavior';
import styles from './fit-fav.css';

class FitFav extends FitStorageBehavior(LitElement) {
  static get is() { return 'fit-fav'; }

  static get styles() { return styles; }

  render() {
    return html`
      <span class="fit-fav__pager" ?faved="${this.faved}">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" xml:space="preserve" height="24" width="24">
          <path class="fit-fav__icon fit-fav__icon--not-faved" d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"></path>
          <path class="fit-fav__icon fit-fav__icon--faved" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path>
        </svg>
      </span>
      <slot name="headline"></slot>
      <span id="text" class="text">
        <slot></slot>
      </span>`;
  }

  static get properties() {
    return {
      code: {
        type: String,
      },

      favList: {
        type: Array,
      },

      faved: {
        type: Boolean,
      },
    };
  }

  get storageName() {
    return 'fit-fav';
  }

  set storageValue(favList) {
    favList = favList || [];
    this.favList = favList;
    this.faved = this.code ? favList.includes(this.code) : null;
  }

  constructor() {
    super();
    this.addEventListener('click', this.toggle);
  }

  connectedCallback() {
    super.connectedCallback();
    this.initialized = true;
  }

  toggle(event) {
    if (event instanceof Event) {
      event.preventDefault();
    }

    const index = this.favList.indexOf(this.code);
    if (index === -1) {
      this.favList.push(this.code);
      this.saveStorageValue(this.favList);
      fetch(this._buildFavTrackingUrl());
    } else if (index >= 0) {
      this.favList.splice(index, 1);
      this.saveStorageValue(this.favList);
    }
  }

  _buildFavTrackingUrl() {
    return `/json/rememberhotel/?${new URLSearchParams({ h: this.code })}`;
  }
}

customElements.define('fit-fav', FitFav);
